import styled from 'styled-components'
import { Sparkles } from 'lucide-react'

/**
 * Small "New" tag. Place it inside a `position: relative` parent
 * (it sits on the top-right corner).
 */
export const NewBadge = () => (
  <Badge>
    <Sparkles size={11} aria-hidden="true" />
    New
  </Badge>
)

const Badge = styled.span`
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  top: -10px;
  right: -6px;
  padding: 1px 7px;
  border-radius: 100px;
  background: #bbe148;
  color: #0e6409;
  border: 1px solid #0e6409;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.02em;
  pointer-events: none;

  @media (max-width: 768px) {
    right: 16px;
  }

  @media (prefers-reduced-motion: no-preference) {
    animation: newBadgePulse 2s ease-in-out infinite;
  }

  @keyframes newBadgePulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.08);
    }
  }
`
